export default "/*Squares*/\n\n#squares {\n    width: 100%;\n}\n\n.row {\n    display: flex;\n    justify-content: center;\n}\n";